module.exports = __webpack_public_path__ + "static/img/end.2d3c6221.jpg";